<template>
  <div>
    <MapModal
      :modalNode="modalNode"
      title="操作"
      id="screenplay"
      :close="close"
    >
      <template slot="content">
        <div class="screenplay-box">
          <!-- <el-scrollbar style="height: 670px;"> -->
          <!-- {{ tableData }} -->
          <!-- tab-position="left" -->
          <el-tabs
            v-model="tabModel"
            v-loading="loading"
            element-loading-background="rgba(0, 0, 0, 0.2)"
            @tab-click="tabsChange"
          >
            <el-tab-pane label="操作列表" name="list">
              <el-scrollbar style="height: 670px;">
                <el-table
                  :data="tableData"
                  border
                  row-key="id"
                  height="600"
                  :empty-text="emptyText"
                  class="operationListClass"
                >
                  <el-table-column prop="id" label="ID" width="180">
                  </el-table-column>
                  <el-table-column label="操作详情">
                    <template slot-scope="scope">
                      <div class="">
                        <p
                          class="operation-list"
                          v-if="scope.row.operate.length == 0"
                        >
                          暂无操作
                        </p>
                        <el-collapse class="tab-collapse" v-else>
                          <!-- {{ scope.row.operate }} -->
                          <div
                            v-if="scope.row.operate.length == 1"
                            class="operation-name"
                            v-html="operationName(scope.row.operate[0])"
                          ></div>
                          <el-collapse-item
                            name="1"
                            v-if="scope.row.operate.length > 1"
                          >
                            <template slot="title">
                              <div
                                class="operation-name"
                                v-html="
                                  operationName(scope.row.operate[0], '......')
                                "
                              ></div>
                            </template>
                            <template>
                              <div
                                class="operation-list"
                                v-for="(item, i) in scope.row.operate"
                                :key="i"
                              >
                                <div
                                  style="display: flex;align-items: center;"
                                  v-html="operationName(item)"
                                ></div>

                                <!-- <template
                                  v-if="
                                    item.executionProperty == 'show' &&
                                      (item.property == 'add' ||
                                        item.property == 'true') &&
                                      item.property != 'remove' &&
                                      item.type != 'terrain'
                                  "
                                >
                                  <span class="el-link el-link--primary">
                                    显示: {{ item.screenplayName }}
                                  </span>
                                </template>
                                <template
                                  v-if="
                                    item.executionProperty == 'show' &&
                                      (item.property == 'remove' ||
                                        item.property == 'false') &&
                                      item.type != 'terrain'
                                  "
                                >
                                  <span class="el-link el-link--danger">
                                    隐藏: {{ item.screenplayName }}
                                  </span>
                                </template>

                                <template
                                  v-if="
                                    item.executionProperty == 'overallStaining'
                                  "
                                >
                                  <span class="el-link el-link--warning">
                                    着色: {{ item.screenplayName }}
                                  </span>
                                </template>

                                <template v-if="item.type == 'roaming'">
                                  <span class="el-link el-link--warning">
                                    漫游: {{ item }}
                                  </span>
                                </template>

                                <template v-if="item.type == 'underground'">
                                  <span class="el-link el-link--warning">
                                    环境透明度:
                                    {{ item.property }}
                                  </span>
                                </template>

                                <template v-if="item.type == 'terrain'">
                                  <span class="el-link el-link--warning">
                                    地形服务:
                                    {{ item.property ? "开启" : "关闭" }}
                                  </span>
                                </template>
                                <span
                                  class="el-link el-link--success"
                                  v-if="item.type == 'flight'"
                                >
                                  移动到 经度:{{
                                    JSON.parse(item.property).lng
                                  }}
                                  , 纬度:{{ JSON.parse(item.property).lat }} ,
                                  高度:{{ JSON.parse(item.property).alt }}
                                </span>

                                <span v-else-if="item.type == 'splitScreen'">
                                  <span class="el-link el-link--primary"
                                    >双屏操作</span
                                  >
                                </span> -->
                              </div>
                            </template>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column prop="updatedTime" label="时间" width="180">
                  </el-table-column>
                  <el-table-column prop="name" label="名称" width="180">
                  </el-table-column>

                  <el-table-column label="" width="180">
                    <template slot-scope="scope">
                      <el-button
                        v-if="1"
                        @click="screenplayEdit(scope.row)"
                        class="screenplay-delete"
                        type="primary"
                        icon="el-icon-edit"
                      ></el-button>
                      <el-button
                        @click="screenplayDelete(scope.row)"
                        class="screenplay-delete"
                        type="danger"
                        icon="el-icon-delete"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="submit">
                  <el-button type="primary" @click="close">
                    关闭
                  </el-button>
                </div>
              </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane :label="operationLabel" name="add">
              <el-scrollbar style="height: 670px;" class="scrollbarMarginTop">
                <AddScreenplay
                  :resourceOptions="resourceOptions"
                  :scenesId="selectedScene.id"
                  :screenplayInit="init"
                  :modelPreview="modelPreview"
                  :operationLabel="operationLabel"
                  ref="addScreenplay"
                >
                </AddScreenplay>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
        </div>
      </template>
    </MapModal>
  </div>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");
const AddScreenplay = () =>
  import("@/components/tables/program/screenplay/Add.vue");
import * as plotOperation from "@/components/tables/plotItem/plotConfig.js";
import * as modelCut from "@/components/tables/newModelCut/map.js";
import {
  getProjectBimModel,
  getProjectShpInfo,
  getDropDownTreeList,
  getKmlInfo,
  getDropDownList,
  getKmlDropDownList,
  getShpInfoDropDownList,
  getBimPlanPaintingDropDownList,
  getBimPlanScenesMethodList,
  postBimPlanScenesMethodListDeletes,
  postBimPlanScenesMethodeditSort,
} from "@/api/api";
import { typeCorrespondence } from "./configure.js";
import Sortable from "sortablejs";
import { Switch } from "element-ui";
export default {
  name: "screenplay",
  components: { MapModal, AddScreenplay },
  props: ["close", "selectedScene", "resourceTreeCheck"],
  data() {
    return {
      typeCorrespondence: typeCorrespondence,
      modalNode: {
        program: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 4,
            left: 25,
            unit: "%", // 默认px
          },
          width: "70%", // 宽度配置 默认450px
          height: "790px", // 配置模态框中心高度
          //模态框head配置
          head: {
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      loading: true,
      tabModel: "list",
      resourceOptions: { model: [], kml: [], shp: [], plot: [], pit: [] },
      tableData: [],
      operationLabel: "添加操作",
      emptyText: " ",
    };
  },
  computed: {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },

  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    // tabs切换
    tabsChange(tab, event) {
      if (tab.name === "list") {
        this.operationLabel = "添加操作";
        this.$refs.addScreenplay.judgeEditComplete();
      } else if (tab.name === "add") {
        screenplay.initial("notAutomatically");
        // this.close();
        if (this.resourceTreeCheck) this.resourceTreeCheck("init");
      }
    },
    // 编辑操作
    screenplayEdit(data) {
      this.tabModel = "add";
      this.operationLabel = "编辑操作";
      this.$refs.addScreenplay.echoData(data, "edit");
      screenplay.initial("notAutomatically");
      // this.close();
      if (this.resourceTreeCheck) this.resourceTreeCheck("init");
    },
    // 预览
    modelPreview(state = false) {
      this.modalNode.program.head.fold.state = state;
    },
    deleteEmptyChildren(data) {
      // console.log(data[0].children);
      if (data && data.length > 0) {
        data.forEach((item, index) => {
          if (item.children?.length == 0 && item.id != "-1") {
            delete item.children;
          } else {
            this.deleteEmptyChildren(item.children);
          }
        });
      }
      return data;
    },

    getModelNode() {
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        scenesId: this.selectedScene.id,
      };
      // 发送请求调用回调展示数据
      getDropDownList(params).then((res) => {
        let { data } = res.data;
        this.resourceOptions.model =
          data[0].children.length > 0 ? this.deleteEmptyChildren(data) : data;
        console.log("模型树", this.resourceOptions.model);
      });
      getKmlDropDownList(params).then((res) => {
        let { data } = res.data;
        this.resourceOptions.kml = this.deleteEmptyChildren(data);
        // this.resourceOptions.kml = [
        //   {
        //     id: -1,
        //     value: "-1",
        //     title: "kml资源",
        //     children: this.deleteEmptyChildren(data),
        //   },
        // ];
        // console.log("kml", this.resourceOptions.kml);
      });
      getShpInfoDropDownList(params).then((res) => {
        let { data } = res.data;
        this.resourceOptions.shp = this.deleteEmptyChildren(data);
        // this.resourceOptions.shp = [
        //   {
        //     id: -1,
        //     value: "-1",
        //     title: "shp资源",
        //     children: this.deleteEmptyChildren(data),
        //   },
        // ];
      });
      getBimPlanPaintingDropDownList(params).then((res) => {
        let { data } = res.data;
        this.resourceOptions.plot = data;
        // console.log("模型树", this.resourceOptions.model);
        // data[0].children.length > 0 ? this.deleteEmptyChildren(data) : data;
      });
      getDropDownTreeList(params).then((res) => {
        let { data } = res.data;
        this.resourceOptions.pit = this.deleteEmptyChildren(data);
      });
      this.getList();
    },

    getList() {
      const params = {
        projectId: window.sessionStorage.getItem("nowProjectId"),
        scenesId: this.selectedScene.id,
      };
      getBimPlanScenesMethodList(params)
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            console.log(data);
            this.tableData = data.methodList;
            // // 传递数据过去，告知当前渲染标绘数据
            // plotOperation.receivePlotTreeData({
            //   children: data.paintingData,
            //   parentId: this.selectedScene.id,
            // });
            if (this.tableData.length == 0) {
              this.emptyText = "暂无数据";
            } else {
              this.emptyText = " ";
            }

            modelCut.getCutList(data.modeSlicedData);
            this.loading = false;
            let _this = this;
            this.$nextTick(function() {
              _this.rowDrop();
            });
          } else {
            this.$notify({
              title: "获取操作失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "获取操作失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    },

    // 行拖动
    rowDrop() {
      // 要侦听拖拽响应的DOM对象
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        animation: 300,
        // 结束拖拽后的回调函数
        onEnd({ newIndex, oldIndex }) {
          // console.log("拖动了行，当前序号：" + newIndex);
          const currentRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currentRow);
          _this.postRowDrop();
        },
      });
    },

    postRowDrop: _.debounce(function(item) {
      let data = { IdSortList: [] };
      this.tableData.forEach((item, index) => {
        data.IdSortList.push(item.id);
        // console.log(item);
      });
      postBimPlanScenesMethodeditSort(data)
        .then((res) => {
          let { data, code } = res.data;
          if (code == 200 || code == 204) {
            console.log(data);
          } else {
            this.$notify({
              title: "排序失败,请刷新页面",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
            this.$NProgress.done(true);
          }
        })
        .catch((error) => {
          console.log(error);
          this.$notify({
            title: "排序失败,请刷新页面",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
          this.$NProgress.done(true);
        });
    }, 1500),
    // 删除操作
    screenplayDelete(data) {
      this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          postBimPlanScenesMethodListDeletes({
            id: data.id,
          })
            .then((res) => {
              let { data, code } = res.data;
              if (code == 200 || code == 204) {
                this.$refs.addScreenplay.initEditValue();
                this.init();
              } else {
                this.$notify({
                  title: "获取操作失败",
                  message: "",
                  type: "error",
                  duration: 1000,
                  offset: 320,
                });
                this.$NProgress.done(true);
              }
            })
            .catch((error) => {
              console.log(error);
              this.$notify({
                title: "获取操作失败",
                message: "",
                type: "error",
                duration: 1000,
                offset: 320,
              });
              this.$NProgress.done(true);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消",
          });
        });
    },
    init() {
      this.loading = true;
      this.tabModel = "list";
      this.getModelNode();
      this.$refs.addScreenplay.init();
    },
    operationName(data, text = "") {
      /*
        type => 被操作对象
        executionProperty => 操作方法
        property => 操作方法接收的参数
        screenplayName => 名称
      */
      let { type, property, executionProperty, screenplayName } = data;
      let html;
      switch (executionProperty) {
        // 飞行
        case "flight":
          html = `<span  class="el-link el-link--success">移动到 经度: ${
            JSON.parse(data.property).lng
          }, 纬度: ${JSON.parse(data.property).lat},高度: ${
            JSON.parse(data.property).alt
          }`;
          html + `${text}</span>`;
          break;
        // 显示/隐藏/地形
        case "show":
          if (property == "add" || property == true || property == "true") {
            // 显示
            html = `<span class="el-link el-link--primary">
             显示:
              `;
          } else {
            // 隐藏
            html = `<span class="el-link el-link--danger">
              隐藏:
              `;
          }
          switch (type) {
            case "model":
              html += `模型 `;
              break;
            case "plot":
              html += `标绘 `;
              break;
            case "kml":
              html += `kml `;
              break;
            case "shp":
              html += `shp `;
              break;
            case "pit":
              html += `挖坑 `;
              break;
            case "terrain":
              html += `地形服务 `;
              break;
            case "roaming":
              html += `漫游 `;
              break;
          }
          if (screenplayName) {
            html += screenplayName;
          }
          html += `${text}</span>`;
          break;
        case "overallStaining":
          html = `<span  class="el-link el-link--warning">着色: ${screenplayName} ${text}</span><div style='background: ${property};width: 20px;height: 20px;margin: 0 5px;border-radius: 50%;border: 2px solid #fff;flex-shrink: 0;'></div>`;
          break;
        case "opacity":
          html = `<span  class="el-link el-link--warning">环境透明: ${property} ${text}</span>`;
          break;
        case "operate":
          if (type == "fixedRoute") {
            html = `<span  class="el-link el-link--warning">开启交通模拟 ${text}</span>`;
          } else {
            html = `<span  class="el-link el-link--warning">开启飞行漫游 ${text}</span>`;
          }

          break;
        case "fly":
          html = `<span  class="el-link el-link--warning">开启绕点飞行 ${text}</span>`;
          break;
        case "open":
          html = `<span  class="el-link el-link--warning">双屏操作 ${text}</span>`;
          break;
        case "start":
          if (type == "sectioning") {
            html = `<span  class="el-link el-link--warning">模型剖切方案：${screenplayName} ${text}</span>`;
          } else if (type == "animation") {
            html = `<span  class="el-link el-link--warning">施工模拟：${screenplayName} ${text}</span>`;
          }
          break;

        //  case "start":
        //           if (type == "animation") {
        //             html = `<span  class="el-link el-link--warning">模型剖切方案：${screenplayName} ${text}</span>`;
        //           }
        //           break;

        default:
          break;
      }

      return html;
    },
  },
  mounted() {
    //实例被挂载后调用，这时 el 被新创建的 vm.el 替换了。如果根实例挂载到了一个文档内的元素上，
    //当 mounted 被调用时 vm.el 也在文档内。
    this.getModelNode();
  },
  watch: {
    selectedScene(n) {
      console.log("监听", this.$refs.addScreenplay, n.name);
      this.init();
    },
  },
  destroyed() {},
};
</script>
<style lang="scss" scoped>
.screenplay-box {
  padding: 20px;
  background: rgba(30, 36, 50, 0.8);
  /deep/ .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  /deep/ .el-tabs__item {
    color: rgba(255, 255, 255, 0.9);
  }
  /deep/ .el-table {
    border: 0;
    &:before {
      height: 0;
    }
    &:after {
      width: 0;
    }
  }

  /deep/ .el-table,
  /deep/ .el-table th,
  /deep/ .el-table tr,
  /deep/ .el-table td {
    background-color: transparent;
    border-right: 0;
    // border-bottom: 1px solid #b0b0b0;
  }
  /deep/ .el-table th > .cell,
  /deep/.el-table .cell {
    color: rgba(255, 255, 255, 0.9) !important;
  }
  /deep/.el-table--enable-row-hover.el-table__bodytr:hover > td,
  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(235, 245, 251, 0.12) !important;
  }
  /deep/ tbody tr:last-child td {
    border-bottom: 0 !important ;
  }
  /deep/ .el-table--enable-row-transition .el-table__body td:last-child,
  /deep/ .el-table th:not(.gutter):nth-last-child(2) {
    border-right: 0 !important;
  }
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    background-color: transparent;
  }
}
.operation-name {
  display: flex;
  align-items: center;
  height: 48px;
  /deep/ .el-link {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
}
.operation-list {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  min-height: 48px;
  span {
    margin-right: 5px;
    // font-weight: bold;
  }
  .operation-name {
  }
}
.screenplay-delete {
  padding: 5px 8px;
  font-size: 14px;
}

.screenplay-box /deep/ .el-table__body-wrapper tbody tr {
  cursor: all-scroll;
}
.tab-collapse {
  border: 0;
  /deep/ .el-collapse-item__header {
    justify-content: left;
    align-items: center;
    display: flex;
    flex-direction: row-reverse;
    background: transparent;
    color: rgba(255, 255, 255, 0.9) !important;
    border: 0 !important;
    // &.is-active {
    //   .operation-name {
    //     display: none;
    //   }
    // }
  }
  /deep/ .el-collapse-item__wrap {
    background: transparent;
    .el-collapse-item__content {
      padding-bottom: 0;
      .operation-list {
        min-height: auto;
      }
    }
  }
}
.scrollbarMarginTop /deep/.el-scrollbar__wrap {
  margin-top: 60px;
  height: calc(var(--scrollbarH) - 150px);
  // height: 85%;
}
.submit {
  position: absolute;
  bottom: 0;
  right: 0;
  z-index: 9999999;
  /deep/ .el-button--primary:hover,
  /deep/ .el-button--primary:hover {
    background-color: #66b1ff !important;
    border-color: #66b1ff !important;
  }
}
.operationListClass {
  border-bottom: none !important;
  /deep/ .el-table__body-wrapper {
    &::-webkit-scrollbar {
      // 整个滚动条
      width: 0; // 纵向滚动条的宽度
      background: rgba(213, 215, 220, 0.3);
      border: none;
    }
    &::-webkit-scrollbar-track {
      // 滚动条轨道
      border: none;
    }
  }

  // --------------------隐藏table gutter列和内容区右侧的空白 start
  /deep/ .el-table th.gutter {
    display: none;
    width: 0;
  }
  /deep/ .el-table colgroup col[name="gutter"] {
    display: none;
    width: 0;
  }

  /deep/ .el-table__body {
    width: 100% !important;
    border-bottom: 1px solid #b0b0b0;
  }
  /deep/.el-table__row td {
    border-bottom: 1px solid #b0b0b0 !important;
  }
  /deep/.has-gutter th {
    border-bottom: 1px solid #b0b0b0 !important;
  }
}
</style>
